/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface SamplingConfigStoppingCondition
 *
 */
// create custom validators for the regexes
export interface SamplingConfigStoppingCondition {
    /**
     * How many samples/images should be used for the sampling. 0-1 represents a percentage of all. 1-N are absolute numbers
     * #type number
     * #memberof SamplingConfigStoppingCondition
        
        
         */
    nSamples?: number;
    /**
     * The minimum distance sampled images should have. Before the distance would fall below, the sampling is stopped.
     * #type number
     * #memberof SamplingConfigStoppingCondition
        
        
         */
    minDistance?: number;
}
/**
 * Check if a given object implements the SamplingConfigStoppingCondition interface.
 */
export function instanceOfSamplingConfigStoppingCondition(value: object): boolean {
    let isInstance = true;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const SamplingConfigStoppingConditionTypiaAssertEquals = (input: any) => {
    return ((input: any): SamplingConfigStoppingCondition => {
        const __is = (input: any, _exceptionable: boolean = true): input is SamplingConfigStoppingCondition => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples) && (undefined === input.minDistance || "number" === typeof input.minDistance) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["nSamples", "minDistance"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is SamplingConfigStoppingCondition => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.minDistance || "number" === typeof input.minDistance || $guard(_exceptionable, {
                    path: _path + ".minDistance",
                    expected: "(number | undefined)",
                    value: input.minDistance
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["nSamples", "minDistance"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "SamplingConfigStoppingCondition",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "SamplingConfigStoppingCondition",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const SamplingConfigStoppingConditionTypiaAssertStringify = (input: SamplingConfigStoppingCondition): string => {
    return ((input: any): string => { const assert = (input: any): SamplingConfigStoppingCondition => {
        const __is = (input: any): input is SamplingConfigStoppingCondition => {
            const $io0 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples)) && (undefined === input.minDistance || "number" === typeof input.minDistance && !Number.isNaN(input.minDistance));
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is SamplingConfigStoppingCondition => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.minDistance || "number" === typeof input.minDistance && !Number.isNaN(input.minDistance) || $guard(_exceptionable, {
                    path: _path + ".minDistance",
                    expected: "(number | undefined)",
                    value: input.minDistance
                }));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "SamplingConfigStoppingCondition",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "SamplingConfigStoppingCondition",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: SamplingConfigStoppingCondition): string => {
        const $tail = (typia.createAssertStringify as any).tail;
        const $so0 = (input: any): any => `{${$tail(`${undefined === input.nSamples ? "" : `"nSamples":${undefined !== input.nSamples ? input.nSamples : undefined},`}${undefined === input.minDistance ? "" : `"minDistance":${undefined !== input.minDistance ? input.minDistance : undefined}`}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const SamplingConfigStoppingConditionValidatorShape = {
    'nSamples': yup.number(),
    'minDistance': yup.number(),
};
export const SamplingConfigStoppingConditionValidator = yup.object().shape(SamplingConfigStoppingConditionValidatorShape);
export const SamplingConfigStoppingConditionStringifyShapeProperties: ObjectSchema['properties'] = {
    'nSamples': {
        'type': 'number',
    } as unknown as fastJSON.NumberSchema,
    'minDistance': {
        'type': 'number',
    } as unknown as fastJSON.NumberSchema,
};
export const SamplingConfigStoppingConditionStringifyShape: ObjectSchema = {
    title: 'SamplingConfigStoppingCondition Stringifier',
    type: 'object',
    properties: {
        ...SamplingConfigStoppingConditionStringifyShapeProperties
    },
    required: [],
};
export const SamplingConfigStoppingConditionStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(SamplingConfigStoppingConditionStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const SamplingConfigStoppingConditionStringify: (data: SamplingConfigStoppingCondition) => string = SamplingConfigStoppingConditionStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function SamplingConfigStoppingConditionFromJSON(json: any): SamplingConfigStoppingCondition {
    return SamplingConfigStoppingConditionFromJSONTyped(json, false);
}
export function SamplingConfigStoppingConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SamplingConfigStoppingCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'nSamples': !exists(json, 'nSamples') ? undefined : json['nSamples'],
        'minDistance': !exists(json, 'minDistance') ? undefined : json['minDistance'],
    };
}
export function SamplingConfigStoppingConditionToJSON(value?: SamplingConfigStoppingCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nSamples': value.nSamples,
        'minDistance': value.minDistance,
    };
}
